import Vue from "vue";
import apiSkobo from "@/helpers/api/apiSkobo";
import ConfidentialFolder from "@/models/People.js/ConfidentialFolder";

export const confidential_state = {
  unregisteredPeopleList: [],
  accessForPersonIdMap: {}
};

export const confidentialFolder_actions = {
  /**
   * Load unregistered people if not already loaded
   */
  async loadUnregisteredPeople() {
    if (!this.unregisteredPeopleList?.length) {
      await this.reloadUnregisteredPeople();
    }
  },

  /**
   * Reload unregistered people from backend
   */
  async reloadUnregisteredPeople() {
    const response = await apiSkobo.get("/v2/appconfidentialfolder/obs/list");
    this.unregisteredPeopleList = response.data.map(confidentialFolder => new ConfidentialFolder(confidentialFolder));
  },

  /**
   * Archive a persons confidential documents - with a target back-end will move them to target.
   * @param { string } userId guid of confidential folder to archive
   * @param { string } target guid of target to move documents to on archive - optional
   */
  async archiveConfidentialFolder(userId, target) {
    await apiSkobo.post(
      `/v2/appconfidentialfolder/obs/userfolders/${userId}/archive`,
      target ? { targetId: target.id } : null
    );
    await this.reloadUnregisteredPeople();
  },

  async loadAccessForPerson(personId) {
    if (!this.accessForPersonIdMap[personId]) {
      await this.reloadAccessForPerson(personId);
    }

    return this.accessForPersonIdMap[personId];
  },

  async reloadAccessForPerson(personId) {
    const response = await apiSkobo.get(`/AppConfidentialFolder/GetEnrolledUsers?personId=${personId}`);

    const accessMap = {};

    response.data?.enrolledSections.forEach(es => {
      const read = es.additionalRoles?.includes("ManuelLæs");
      const write = es.additionalRoles?.includes("ManuelSkriv");

      accessMap[es.sectionId] = {
        classRead: read || write,
        classWrite: write,
        classMIS: !read && !write,
        state: es.roleStatus
      };
    });
    Vue.set(this.accessForPersonIdMap, personId, accessMap);
  },

  async addAccessForPerson(personId, sectionId, permission) {
    await apiSkobo.post(
      `/AppConfidentialFolder/UpsertEnrolledUser?personId=${personId}&sectionId=${sectionId}&permission=${permission}`
    );

    await this.reloadAccessForPerson(personId);
  },

  async removeAccessForPerson(personId, sectionId) {
    await apiSkobo.delete(`/AppConfidentialFolder/DeleteEnrolledUser?personId=${personId}&sectionId=${sectionId}`);

    await this.reloadAccessForPerson(personId);
  }
};

export const confidentialFolder_getters = {
  unregisteredPeople: state => state.unregisteredPeopleList,

  unRegisteredPersonById: state => personId => {
    return state.unregisteredPeopleList.find(cf => cf.userId === personId);
  },

  accessForPersonId: state => personId => state.accessForPersonIdMap[personId]
};
